import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"

const deontologie = () => {
  return (
    <Layout>
      <SEO title="Déontologie" />
      <div className="container py-5">
        <div className="row">
          <div className="col-md-12">
            <h2>Déontologie</h2>
          </div>
          <div className="col-md-12 mt-5 mb-3">
            <h3>
              <span role="img" aria-label="Scroll">
                📜
              </span>{" "}
              CODE DE DEONTOLOGIE DE LA SOCIETE FRANCAISE DE SOPHROLOGIE
            </h3>
            <p>
              <strong>PREAMBULE</strong>
              <br />
              Tous les membres de la S.F.S. sont tenus d’exercer dans le respect
              des lois et des règlements régissant leur profession, dans le
              respect de l’intégrité et de la dignité des personnes en
              traitement et dans le respect de ce code de déontologie.
            </p>
            <p>
              <strong>I) CHAMPS D’APPLICATION</strong>
              <br />
              Le présent code engage tous les organismes ainsi que tous les
              membres individuels adhérents à la Société Française de
              Sophrologie.
            </p>
            <p>
              <strong>II) PRATIQUE DE LA SOPHROLOGIE</strong>
              <br />
              La sophrologie dans ses branches médicales, paramédicales et
              sociales, est une discipline du domaine des sciences humaines.
              Elle implique la mise en oeuvre de moyens qui tendent vers
              l’autonomie et le mieux-être des patients/clients/élèves dans le
              respect des croyances de chacun (religieuses, politiques,
              philosophiques). Cette préoccupation s’applique également au
              sophrologue s’exprimant en public : En s’interdisant toute
              pratique ou pression pouvant mettre en péril l’intégrité du
              patient/client/élève, En fixant les honoraires avec mesure et en
              s’interdisant toute exploitation matérielle ou financière, En
              respectant et en faisant respecter les règles de confidentialité.
            </p>
            <p>
              <strong>III) COMPETENCE PROFESSIONNELLE</strong>
              <br />
              Le Sophrologue doit exercer avec compétence et dans le respect des
              règles éthiques. Pour cela, il doit avoir suivi une formation
              reconnue par la S.F.S., se tenir informé des recherches et
              développements de la discipline et de ses techniques. Ne pratiquer
              que dans les domaines où il peut justifier de connaissances et
              d’une expérience suffisante.
            </p>
            <p>
              <strong>IV) SECRET PROFESSIONNEL</strong>
              <br />
              Les sophrologues sont soumis au secret professionnel absolu
              concernant tout ce qui leur est confié dans l’exercice de leur
              profession. Ce secret s’applique dans les limites des lois et
              règlements (notamment quand des mineurs sont concernés). V)
              OBLIGATIONS DU PRATICIEN EN SOPHROLOGIE Tout praticien doit
              informer les patients/clients/élèves de : Leurs droits, De la
              méthode employée, Des conditions financières, Du secret
              professionnel, Du libre choix du praticien, De la durée moyenne du
              traitement. Ces informations doivent être exactes et objectives.
              En outre ceux qui exercent en tant que sophro-thérapeute doivent
              justifier d’une formation en psychothérapie ou psychanalyse, ou
              d’un titre de psychologue clinicien ou de psychiatre, de la
              maîtrise des techniques de la sophrologie, d’une supervision et
              d’un contrôle de cas.
            </p>
            <p>
              <strong>RECOURS</strong>
              <br />
              Toute infraction à une règle déontologique peut faire l’objet d’un
              recours devant la Société Française de Sophrologie, qui réunit une
              commission en vue de se prononcer sur le litige évoqué. En cas de
              non-respect des règles déontologiques, des sanctions peuvent êtres
              envisagées à l’égard du sophrologue défaillant pouvant aller
              jusqu’à l’exclusion de la S.F.S. Le plaignant doit être informé de
              ses possibilités de recours judiciaires.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default deontologie
